import { createContext } from 'react';
import type {
  NotificationCategory,
  NotificationFilters,
  NotificationPublishInput,
  NotificationRecord,
  NotificationTransportMode,
} from '@/notifications/NotificationTypes';

export interface NotificationContextValue {
  notifications: NotificationRecord[];
  unreadCount: number;
  isLoading: boolean;
  isConnected: boolean;
  transportMode: NotificationTransportMode;
  filters: NotificationFilters;
  categories: NotificationCategory[];
  refresh: () => Promise<void>;
  setFilters: (updates: Partial<NotificationFilters>) => void;
  resetFilters: () => void;
  markRead: (id: string) => Promise<void>;
  markUnread: (id: string) => Promise<void>;
  archive: (id: string) => Promise<void>;
  remove: (id: string) => Promise<void>;
  markAllRead: () => Promise<void>;
  markManyRead: (ids: string[]) => Promise<void>;
  archiveMany: (ids: string[]) => Promise<void>;
  deleteMany: (ids: string[]) => Promise<void>;
  publish: (input: NotificationPublishInput) => Promise<void>;
  connect: (mode?: NotificationTransportMode) => Promise<void>;
  disconnect: () => Promise<void>;
}

export const defaultFilters: NotificationFilters = {
  search: '',
  category: 'all',
  severity: 'all',
  status: 'all',
  dateRange: 'all',
  productId: 'all',
};

export const NotificationContext = createContext<
  NotificationContextValue | undefined
>(undefined);
